"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DataTabs = function DataTabs(props) {
  var activeBgColor = props.activeBgColor,
      activeKey = props.activeKey,
      activeTextColor = props.activeTextColor,
      bordered = props.bordered,
      children = props.children,
      wrapperClassName = props.className,
      commonTabContent = props.commonTabContent,
      disableTransition = props.disableTransition,
      hoverBgColor = props.hoverBgColor,
      hoverTextColor = props.hoverTextColor,
      onSelectTab = props.onSelectTab,
      tabContentClassName = props.tabContentClassName,
      vertical = props.vertical;

  var getFirstTabKey = function getFirstTabKey() {
    var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _children = (0, _slicedToArray2.default)(children, 1),
        firstItem = _children[0];

    return firstItem && firstItem.props.tabKey;
  };

  var _useState = (0, _react.useState)(activeKey || getFirstTabKey(props.children)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      internalActiveKey = _useState2[0],
      setInternalActiveKey = _useState2[1];

  (0, _react.useEffect)(function () {
    activeKey && setInternalActiveKey(activeKey);
  }, [activeKey]);

  var handleSelectTab = function handleSelectTab(event) {
    onSelectTab(event.currentTarget.getAttribute('data-tabkey'));
  };

  var wrapperClassNames = (0, _classnames.default)('DataTabsContainer', bordered && 'DataTab-bordered', wrapperClassName, vertical && 'DataTabs-vertical');

  var enrichChildren = function enrichChildren() {
    return _react.default.Children.map(children, function (child) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        active: child.props.tabKey === internalActiveKey,
        disableTransition: disableTransition
      });
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'DataTabsWrapper'
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: 'DataTabs',
    role: 'tabList'
  }, _react.default.Children.map(children, function (child) {
    var _child$props = child.props,
        tabKey = _child$props.tabKey,
        className = _child$props.className,
        title = _child$props.title;
    var isActive = tabKey === internalActiveKey;
    var tabClassNames = (0, _classnames.default)('DataTab', 'tab', !isActive && "".concat(hoverTextColor, " ").concat(hoverBgColor, " cursor-pointer"), isActive && "active ".concat(activeTextColor, " ").concat(activeBgColor), className && className);
    return /*#__PURE__*/_react.default.createElement("li", {
      key: tabKey,
      className: tabClassNames,
      onClick: handleSelectTab,
      "data-tabkey": tabKey
    }, title, /*#__PURE__*/_react.default.createElement("div", {
      className: "arrow ".concat(isActive ? 'in' : '')
    }));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "tab-content ".concat(tabContentClassName),
    role: 'tabpanel'
  }, commonTabContent ? commonTabContent : enrichChildren()));
};

DataTabs.defaultProps = {
  activeKey: '',
  onSelectTab: function onSelectTab() {},
  className: '',
  tabContentClassName: '',
  mountOnEnter: true,
  unmountOnExit: true,
  hoverTextColor: 'hover-text-color-darkest',
  hoverBgColor: 'hover-bg-highlight-decent',
  activeTextColor: 'text-color-white',
  activeBgColor: 'bg-highlight-dark',
  bordered: true,
  disableTransition: false,
  children: [],
  vertical: false
};
DataTabs.propTypes = {
  activeKey: _propTypes.default.string,
  onSelectTab: _propTypes.default.func.isRequired,
  mountOnEnter: _propTypes.default.bool,
  unmountOnExit: _propTypes.default.bool,
  tabContentClassName: _propTypes.default.string,
  hoverTextColor: _propTypes.default.string,
  hoverBgColor: _propTypes.default.string,
  activeTextColor: _propTypes.default.string,
  activeBgColor: _propTypes.default.string,
  bordered: _propTypes.default.bool,
  disableTransition: _propTypes.default.bool,
  className: _propTypes.default.string,
  vertical: _propTypes.default.bool
};
var _default = DataTabs;
exports.default = _default;